export const questions = [
	{
		question: 'Зачем нужны корпоративные HR-опросы для\u00A0сотрудников?',
		answer: (
			<>
				Система корпоративных опросов позволяет выстроить управление удовлетворенностью сотрудников,
				проводить анализ корпоративной эффективности, использовать онлайн-формы анкетирования
				и&nbsp;голосования, чтобы&nbsp;исследовать мнения, проводить тестирование, собирать обратную
				связь от&nbsp;команд онлайн и&nbsp;улучшать коммуникации внутри компании.
				<br />
				<br />
				Опросы можно использовать в&nbsp;качестве инструмента для&nbsp;оценки вовлеченности, сбора
				комментариев, мнений и&nbsp;анонимных отзывов. Корпоративная аналитика отзывов, удобные анкеты
				и&nbsp;опросники для&nbsp;команд позволяют оценить климат в&nbsp;коллективе и&nbsp;улучшить
				корпоративную среду.
			</>
		),
	},
	{
		question: 'Что\u00A0такое Опросы в\u00A0VK Teams?',
		answer: `Опросы\u00A0— сервис для\u00A0проведения тестирования, оценки сотрудников и\u00A0настройки цифровой системы
		анкетирования персонала в\u00A0компании. Это\u00A0один из\u00A0инструментов VK WorkSpace, доступный в\u00A0защищенном пользовательском приложении VK Teams.`,
	},
	{
		question: 'Зачем нужно создание анонимных опросов?',
		answer: `Анонимные анкеты сотрудников в\u00A0сервисе Опросы VK WorkSpace подразумевают, что\u00A0личность
		респондентов сохраняется в\u00A0тайне даже\u00A0после\u00A0завершения опроса. Преимущество такой корпоративной
		системы\u00A0анкетирования онлайн в\u00A0том, что\u00A0сотрудники не\u00A0опасаются идентификации и\u00A0с\u00A0большей
		вероятностью дают честные и\u00A0развернутые ответы. Конфиденциальный сбор отзывов и\u00A0онлайн-анкет для\u00A0сотрудников
		демонстрирует ценности компании, помогает выявить скрытые проблемы и\u00A0усилить контроль удовлетворенности персонала.`,
	},
	{
		question: 'Что\u00A0такое VK WorkSpace?',
		answer: `VK WorkSpace\u00A0— это\u00A0платформа для\u00A0бизнеса от\u00A0российского разработчика корпоративного
		ПО\u00A0VK Tech. Помимо эффективной системы опросов в\u00A0ней\u00A0есть\u00A0почта с\u00A0календарем и\u00A0адресной книгой
		видеоконференции, мессенджер, задачи, заметки, доска для\u00A0идей и\u00A0диск с\u00A0редактором документов.`,
	},
	{
		question: 'Что\u00A0такое VK\u00A0Teams?',
		answer: `VK Teams\u00A0— пользовательское приложение для\u00A0доступа к\u00A0сервисам VK WorkSpace, в\u00A0том\u00A0числе
		 и\u00A0к\u00A0удобному инструменту для\u00A0опросов. В\u00A0приложении можно создавать чат-ботов и\u00A0интегрировать
		 корпоративные приложения на\u00A0HTML5\u00A0и\u00A0JavaScript для\u00A0автоматизации рабочих процессов.
		 Сервисом можно пользоваться с\u00A0компьютера, смартфона и\u00A0планшета.`,
	},
	{
		question:
			'Систему внутренних опросов можно использовать вместе с\u00A0другими сервисами VK WorkSpace?',
		answer: `Сервисы VK WorkSpace доступны по\u00A0единой подписке в\u00A0режиме одного окна из\u00A0приложения VK Teams\u00A0—
		в\u00A0том\u00A0числе и\u00A0инструмент для\u00A0внутренних опросов, голосований, сбора отзывов, мнений и\u00A0предложений в\u00A0компании.`,
	},
];
